// Card/detail images go through Vercel's image optimizer on the live site (resized WebP per screen width).
// REACT_APP_IMAGE_CDN is set only for Vercel builds (scripts/fetch-content.js), so local builds use the raw files.
const ON = process.env.REACT_APP_IMAGE_CDN === '1';
export const WIDTHS = [256, 384, 640, 960, 1280];   // must match "images.sizes" in vercel.json

// Files served by /api/file (screenshots saved by the PC agents) are already 1280px WebP: no optimizer needed.
const optimizable = (src) => ON && src && !src.startsWith('/api/');
export const imgUrl = (src, w) => (optimizable(src) ? `/_vercel/image?url=${encodeURIComponent(src)}&w=${w}&q=72` : src);

// Props for <img>: a srcSet the browser picks from using `sizes`.
export const imgProps = (src, sizes) => (optimizable(src)
  ? { src: imgUrl(src, 640), srcSet: WIDTHS.map((w) => `${imgUrl(src, w)} ${w}w`).join(', '), sizes }
  : { src });
